import { Routes, Route, Navigate } from 'react-router-dom'
import { Layout, Spin } from 'antd'
import AppLayout from './components/layout/AppLayout'
import EmailList from './pages/EmailList'
import EmailThread from './pages/EmailThread'
import Dashboard from './pages/Dashboard'
import NotConnected from './pages/NotConnected'
import LandingPage from './pages/LandingPage'
import FaqPage from './pages/FaqPage'
import { useAuth } from './hooks/useAuth'

const { Content } = Layout

function App() {
  const { isAuthenticated, isLoading, gmailConnected } = useAuth()

  if (isLoading) {
    return (
      <Layout style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Spin size="large" tip="Loading..." />
      </Layout>
    )
  }

  if (!isAuthenticated) {
    return (
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/faq" element={<FaqPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    )
  }

  if (!gmailConnected) {
    return (
      <Layout style={{ minHeight: '100vh' }}>
        <Content>
          <NotConnected />
        </Content>
      </Layout>
    )
  }

  return (
    <AppLayout>
      <Routes>
        <Route path="/" element={<EmailList />} />
        <Route path="/inbox" element={<EmailList />} />
        <Route path="/inbox/promotions" element={<EmailList />} />
        <Route path="/inbox/updates" element={<EmailList />} />
        <Route path="/inbox/social" element={<EmailList />} />
        <Route path="/inbox/forums" element={<EmailList />} />
        <Route path="/inbox/spam" element={<EmailList />} />
        <Route path="/thread/:threadId" element={<EmailThread />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="*" element={<Navigate to="/inbox" replace />} />
      </Routes>
    </AppLayout>
  )
}

export default App

